import type { ContainerSaveFunctions } from './Interfaces';

import { writeFile } from '../Helper';
import { remove } from '../Wrapper';

import { DirectoryContainer } from './DirectoryContainer';

export class DirectoryWriter extends DirectoryContainer implements ContainerSaveFunctions {
    public addFile(data: ArrayBuffer | Blob | string, filename: string): Promise<void> {
        return writeFile(this.getPath(filename), data);
    }

    public delete(path: string): Promise<void> {
        return remove(this.getPath(path));
    }
}
